module.exports = __webpack_public_path__ + "src/assets/textures/leaves/cucumber_leaf_color_map.jpg";